import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { hostCommandDispatchFailed, hostCommandDispatchSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* hostCommandDispatch(action) {
  try {
    const {
      id,
      command,
    } = action.payload;
    const url = `${BACKEND_URL}/host-commands/dispatch`;
    const pool = {
      host_ids: typeof id === 'string' ? [id] : id,
      command_key: command,
    };
    const userDataResponse = yield makeRequest(url, pool, action, 'POST');
    const responseJson = yield userDataResponse.json();
    if (userDataResponse && userDataResponse.status === OK && responseJson) {
      if (
        responseJson.result
        && responseJson.result.commands
        && typeof responseJson.result.commands === 'object'
        && Object.keys(responseJson.result.commands).length === 1) {
        const keys = Object.keys(responseJson.result.commands);
        const status = responseJson.result.commands[keys[0]];
        if (status === 'Хост не найден' || status === 'Операция заблокирована') { // todo этот костыль я крайне осуждаю. Во всем виноват Александр!!!!
          yield put(hostCommandDispatchFailed(responseJson));
          yield call(rejectActionPromise(action, responseJson));
          return;
        }
      }
      yield put(hostCommandDispatchSuccessful(responseJson));
      yield call(resolveActionPromise(action, responseJson));
    } else {
      yield put(hostCommandDispatchFailed(responseJson));
      yield call(rejectActionPromise(action, responseJson));
    }
  } catch (e) {
    yield put(hostCommandDispatchFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
